import { createSlice, PayloadAction, createAction } from '@reduxjs/toolkit';

import { RequestStatus } from 'shared/constants/State';

export interface Patient {
  name: string;
  birthdate_in_years: string;
  occupation: string;
  last_insurance_name: string;
  picture: string;
}

interface InitialState {
  status: RequestStatus;
  data: Patient;
  error: string;
}

export const initialState: InitialState = {
  status: RequestStatus.Ready,
  data: {
    name: '',
    birthdate_in_years: '',
    occupation: '',
    last_insurance_name: '',
    picture: '',
  },
  error: '',
};

const name = 'medicalRecords/root';

const rootSlice = createSlice({
  name,
  initialState,
  reducers: {
    patientSuccess: (state, action: PayloadAction<Patient>) => ({
      ...state,
      data: action.payload,
      status: RequestStatus.Success,
      error: '',
    }),
    patientPending: (state) => ({
      ...state,
      status: RequestStatus.Pending,
      error: '',
    }),
    patientError: (state, action: PayloadAction<string>) => ({
      ...state,
      status: RequestStatus.Error,
      error: action.payload,
    }),
  },
});

export const {
  patientSuccess,
  patientPending,
  patientError,
} = rootSlice.actions;
export const patientInfo = createAction<string>(`${name}/getPatientInfo`);

export default rootSlice.reducer;
